module.exports = __webpack_public_path__ + "img/icon-insurance.9a96645a.svg";